<!--*
 * Screen with the site details
 *
 * @author   pablo.barco
 * @date     2021-02-03
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div id="background">
    <SubMenuHeader
      :title="$t('drillDownScreen.pageTitle')"
      @onGoBack="back"
      @showVideo="$emit('showVideo')"
    />
    <div class="container under-header">
      <DrillDown class="pt-5" />
    </div>
  </div>
</template>

<script>
import SubMenuHeader from '../SubMenuHeader';
import DrillDown from "@/components/drillDown/DrillDown.vue";

export default {
  'name': 'DrillDownScreen',
  'components': { DrillDown, SubMenuHeader },
  'props': {
    'showVideo': {
      'type': Event,
      'required': false
    }
  },
  'methods': {
    back() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
  #background {
    background-color: #fafafa;
    min-height: 100vh;
  }

  .under-header {
    padding-top: 52px;
  }
</style>
